<template>
<div class="lesson" :style="{paddingTop: headerHeight + 'px'}" v-loading="pageLoading">
  <SubHeader :showUser="true"  :showNav="false" v-if="plat!='171' && plat!='107' && plat!='119'"></SubHeader>
  <SubHeaderYingyou :showUser="true"  :showNav="false" v-else></SubHeaderYingyou>
  <div class="box-line" id="line"></div>
  <div class="lesson-content" style="width: 100%;">
    <van-tabs tab-class="item" :ellipsis="false" tab-active-class="active" class="type-select" v-model="classify" @change="getList" v-show="category.length>1">
      <template v-for="(item,index) of category">
        <van-tab :title="item.name"></van-tab>
      </template>
    </van-tabs>
    <div  v-show="category.length<2" style="padding:10px 0"></div>
    <van-list v-loading="listLoading" v-if="list.length" v-model="loading" :finished="finished" finished-text="没有更多了">
      <div class="list">
        <LiveCard v-for="item of list" :key="item.id" :cardData="item"></LiveCard>
      </div>
    </van-list>
    <van-empty style="margin: 0 auto" v-if="!list.length" description="暂无数据" />
  </div>
</div>
</template>

<script>
import PriceCard from "@/components/PriceCard";
import VideoCard from "@/components/VideoCard";
import TopCard from "@/components/TopCard";
import SubHeader from "@/components/SubHeader";
import SubHeaderYingyou from "@/components/SubHeaderYingyou";
import LiveCard from "@/components/LiveCard";

export default {
  name: "lesson",
  components: {
    PriceCard,
    VideoCard,
    TopCard,
    SubHeader,
    LiveCard,
    SubHeaderYingyou
  },
  data() {
    return {
      active: 0,
      list: [],
      tag: 1,
      classify: 0,
      certificate: [],
      topData: [],
      category: [],
      loading: false,
      pageLoading: false,
      finished: true,
      more: false,
      ideaNavData: [],
      ideaAllData: [],
      listLoading: false,
    };
  },
  async mounted() {
    this.getData();
  },
  watch:{
    classify(v){
      console.log('watch',v)
    }
  },
  destroyed() {
  },
  computed: {
    plat() {
      return this.$store.state.plat_id;
    },
    headerHeight() {
      return this.$store.state.headerHeight;
    }
  },
 
  methods: {
    getTag(index) {
      this.tag = index;
    },
    async getList(index) {
      this.listLoading = true;
      this.classify = index;
      console.log(this.classify)
      console.log(this.category, index)
      let res = await this.$api({
        method: "get",
        url: "/api/livestream/list",
        data: {
          category_id: this.category[this.classify].id,
          service_type: this.plat,
          type: 1,
        },
      });
      this.listLoading = false;
      if (res.code == 0) {
        this.list = res.data;
      } else {
        this.$toast(res.msg);
      }
    },
    async getData() {
      this.pageLoading = true;
      let res = await this.$api({
        method: "get",
        url: "/api/livestream/category",
        data: {
          flat_id: this.plat,
        },
      });
      this.pageLoading = false;
      if (res.code == 0) {
        if(res.data.live_type){
          this.category = res.data.live_type;
          this.classify = this.$route.query.index
          await this.getList(this.$route.query.index || 0);
        }
        
      } else {
        this.$toast(res.msg);
      }
    },
    jumpLiveDetail(item) {
      let {
        name,
        video_url,
        host,
        img_url,
        category_name,
        video_id,
        ccid,
        cover,
        id
      } = item;
      let videoId = video_id;
      let type = 'aliyun'
      if (ccid) {
        id = ccid;
        type = 'cc';
      }
      if (video_url) {
        this.$router.push(`./LiveDetail?id=${id}&name=${name}&url=${video_url}&host=${host}&cover=${img_url}&category_name=${category_name}`);
      } else if(videoId){
        this.$router.push(`./LiveDetail?id=${id}&name=${name}&videoId=${videoId}&type=${type}&cover=${cover}`);

      }else{
        this.$toast('没有视频')
      }
      
    },
    getMore() {
      if (this.more) {
        return;
      }
      this.more = true;
      if (this.menu == 2) {
        axios
          .get(
            `/api/platform/pc/category?flat_id=${this.plat}&page=${this.page}`, {}
          )
          .then((res) => {
            this.more = false;
            console.log(res);
            if (res.code == 0) {
              let list = res.data.category[this.classify].goods;
              this.list = this.list.concat(list);
              this.loading = false;
              if (list.length < 10) {
                this.finished = true;
              } else {
                this.finished = false;
              }
            } else {
              this.$toast(res.msg);
            }
          })
          .catch((err) => {
            console.log(err);
            this.more = false;
          });
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    console.log("beforeRouteUpdate");
    // console.log(to);
    next();
  },
};
</script>

<style lang="scss" scoped>
.lesson {
  min-height: calc(100vh - 230px);
  display: flex;
  align-items: flex-start;
  overflow: hidden;
}
</style>

<style lang="scss">
</style>
